import React from 'react';

import { UserRole } from '../../Common/UserRole';
import localStorage from '../../Common/LocalStorage';

// export class RoleSelect extends React.Component {
//     generateSelect = () => {
//         let isDisabled = false;
//
//         if (localStorage.getUsernameRole() === UserRole.PHARMACY_MANAGER) {
//             isDisabled = true;
//         }
//
//         return (
//             <select onChange={this.props.handler} disabled={isDisabled}>
//                 <option value="DEFAULT_VALUE">{isDisabled ? 'Pharmacist' : this.props.placeholder}</option>
//                 {(generateUserRole(this.props.status) || []).map(role => (
//                     <option key={role.title} value={role.value}>
//                         {role.title}
//                     </option>
//                 ))}
//             </select>
//         );
//     };
//
//     render() {
//         return (
//             <div className={`formSelect ${this.props.extraClasses}`}>
//                 <label>{this.props.label}</label>
//                 <div className="selectWrapper">{this.generateSelect()}</div>
//             </div>
//         );
//     }
// }

// export class PharmacySelect extends React.Component {
//     generateSelect = () => {
//         const roleOfLoggedUser = localStorage.getUsernameRole();
//
//         let roleOfRoleSelect = this.props.role;
//         let isDisabled = false;
//         let hasPharmacy = '';
//         let listOfPharmacies = this.props.pharmacyList;
//         if (listOfPharmacies !== null) {
//             hasPharmacy = listOfPharmacies.length !== 0 ? listOfPharmacies[0].name : '';
//         }
//
//         if (roleOfLoggedUser === UserRole.PHARMACY_MANAGER || roleOfRoleSelect === UserRoleValue.STORE_OWNER) {
//             isDisabled = true;
//             listOfPharmacies = [];
//         }
//
//         return (
//             <select onChange={this.props.handler} onBlur={this.props.blured} disabled={isDisabled}>
//                 {isDisabled ? <option value="">{hasPharmacy}</option> : <option value="">{this.props.placeholder}</option>}
//                 {(listOfPharmacies || []).map(pharmacy => (
//                     <option key={pharmacy.id} value={pharmacy.id}>
//                         {pharmacy.name}
//                     </option>
//                 ))}
//             </select>
//         );
//     };
//
//     render() {
//         return (
//             <div className={`formSelect ${this.props.extraClasses}`}>
//                 <label>{this.props.label}</label>
//                 <div className="selectWrapper">{this.generateSelect()}</div>
//             </div>
//         );
//     }
// }

export class CompanySelect extends React.Component {
    generateSelect = () => {
        const userRole = localStorage.getUsernameRole();
        let isDisabled = false;
        let listOfCompanies = this.props.companyList.companies ? this.props.companyList.companies : this.props.companyList;

        if (userRole === UserRole.STORE_OWNER || userRole === UserRole.PHARMACY_MANAGER) {
            isDisabled = true;
        }

        return (
            <select onChange={this.props.handler} disabled={isDisabled} value={this.props.value}>
                {isDisabled ? null : <option value="">{this.props.placeholder}</option>}
                {(listOfCompanies || []).map(company => (
                    <option key={company.id} value={company.id}>
                        {company.name}
                    </option>
                ))}
            </select>
        );
    };
    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}

export class CompanyUserSelect extends React.Component {
    generateSelect = () => {
        
        const freeCompanyOwnersList = this.props.companyOwnerList.companyOwners;
        
        return (
            <select onChange={this.props.handler}>
                <option value="">{this.props.selectDefault}</option>
                {freeCompanyOwnersList.map(owner => {
                    if (owner.names === this.props.companyOwner) {
                        return (
                            <option selected key={owner.id} value={owner.id}>
                                {owner.names}
                            </option>
                        );
                    }

                    return (
                        <option key={owner.id} value={owner.id}>
                            {owner.names}
                        </option>
                    );
                })}
            </select>
        );
    };
    
    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}

export class PharmacyUserSelect extends React.Component {
    generateSelect = () => {
        const freePharmacyManagersList = this.props.pharmacyManagerList && this.props.pharmacyManagerList.pharmacyManages ? this.props.pharmacyManagerList.pharmacyManages : [];
        return (
            <select onChange={this.props.handler} value={this.props.pharmacyManagerId}>
                <option value='null'>{this.props.selectDefault}</option>
                {freePharmacyManagersList.map(manager => {
                    return (
                        <option key={manager.id} value={manager.id}>
                            {manager.names}
                        </option>
                    );
                })}
            </select>
        );
    };

    render() {
        return (
            <div className={`formSelect ${this.props.extraClasses}`}>
                <label>{this.props.label}</label>
                <div className="selectWrapper">{this.generateSelect()}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/customModules/Common/form/Selects.js